/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromotionalLinkModel } from '../../models/promotional-link-model';

export interface AnonymousPromotionalLinkIdGet$Params {
  id: string;
}

export function anonymousPromotionalLinkIdGet(http: HttpClient, rootUrl: string, params: AnonymousPromotionalLinkIdGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<PromotionalLinkModel>> {
  const rb = new RequestBuilder(rootUrl, anonymousPromotionalLinkIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<PromotionalLinkModel>;
    })
  );
}

anonymousPromotionalLinkIdGet.PATH = '/Anonymous/PromotionalLink/{id}';
